export var FailoverStrategy;
(function (FailoverStrategy) {
    FailoverStrategy["AbortOnError"] = "abortOnError";
    FailoverStrategy["TryNextOnError"] = "tryNextOnError";
    FailoverStrategy["SingleEndpoint"] = "singleEndpoint";
    FailoverStrategy["QueryMajority"] = "queryMajority";
})(FailoverStrategy || (FailoverStrategy = {}));
export var ResponseStatus;
(function (ResponseStatus) {
    ResponseStatus["Pending"] = "pending";
    ResponseStatus["Confirmed"] = "confirmed";
    ResponseStatus["Rejected"] = "rejected";
    ResponseStatus["Unknown"] = "unknown";
    ResponseStatus["Waiting"] = "waiting";
})(ResponseStatus || (ResponseStatus = {}));
export var TransactionEvent;
(function (TransactionEvent) {
    TransactionEvent["ClusterAnchoringConfirmation"] = "clusterAnchoringConfirmed";
    TransactionEvent["SystemAnchoringConfirmation"] = "systemAnchoringConfirmed";
    TransactionEvent["DappConfirmed"] = "dappConfirmed";
    TransactionEvent["DappReceived"] = "dappReceived";
    TransactionEvent["Signed"] = "signed";
})(TransactionEvent || (TransactionEvent = {}));
export var AnchoringStatus;
(function (AnchoringStatus) {
    AnchoringStatus["NotAnchored"] = "notAnchored";
    AnchoringStatus["ClusterAnchored"] = "clusterAnchored";
    AnchoringStatus["SystemAnchored"] = "systemAnchored";
    AnchoringStatus["FailedAnchoring"] = "failedAnchoring";
})(AnchoringStatus || (AnchoringStatus = {}));
export var ChainConfirmationLevel;
(function (ChainConfirmationLevel) {
    ChainConfirmationLevel["None"] = "none";
    ChainConfirmationLevel["Dapp"] = "dapp";
    ChainConfirmationLevel["ClusterAnchoring"] = "clusterAnchoring";
    ChainConfirmationLevel["SystemAnchoring"] = "systemAnchoring";
    ChainConfirmationLevel["EvmNetwork"] = "evmNetwork";
})(ChainConfirmationLevel || (ChainConfirmationLevel = {}));
export var Method;
(function (Method) {
    Method["GET"] = "get";
    Method["POST"] = "post";
})(Method || (Method = {}));
//# sourceMappingURL=enums.js.map